import Vue from 'vue'
import VueI18n from 'vue-i18n'

import commonRu from '@/langs/ru.json'
import commonEn from '@/langs/en.json'
import commonUk from '@/langs/uk.json'

import mainMenuSrcRu from '@/mainMenuSrc/langs/ru.json'
import mainMenuSrcEn from '@/mainMenuSrc/langs/en.json'
import mainMenuSrcUk from '@/mainMenuSrc/langs/uk.json'

const ru = {
  ...commonRu,
  ...mainMenuSrcRu
}

const en = {
  ...commonEn,
  ...mainMenuSrcEn
}

const uk = {
  ...commonUk,
  ...mainMenuSrcUk
}

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: localStorage.getItem('language') ? localStorage.getItem('language') : 'ru',
  silentTranslationWarn: true,
  messages: {
    ru,
    en,
    uk
  }
})